import { gql } from 'shared/types/layoutcreator'

export const LOGIN_TO_ADMIN = gql(/* GraphQL */ `
  mutation adminLogin($login: String!, $password: String!) {
    adminLogin(login: $login, password: $password)
  }
`)

export const START_MIGRATION = gql(/* GraphQL */ `
  mutation startImageMigration(
    $groupId: String!
    $projectId: String!
    $author: String
    $type: String
  ) {
    startImageMigration(
      groupId: $groupId
      projectId: $projectId
      author: $author
      type: $type
    )
  }
`)

export const START_PAGE_EXPORT = gql(/* GraphQL */ `
  mutation startExportDocument(
    $groupId: String!
    $projectId: String!
    $documentId: String!
    $outputProfile: String
    $isCoverPage: Boolean
  ) {
    startExportDocument(
      groupId: $groupId
      projectId: $projectId
      documentId: $documentId
      outputProfile: $outputProfile
      isCoverPage: $isCoverPage
    ) {
      documentId
      taskId
      isStarted
      isFinished
      isSucceeded
      isVariableSet
      url
    }
  }
`)

export const FIX_VARIABLES = gql(/* GraphQL */ `
  mutation fixVariables($groupId: String!, $projectId: String!) {
    fixVariables(groupId: $groupId, projectId: $projectId)
  }
`)

export const ADD_NEW_ASSET = gql(/* GraphQL */ `
  mutation addNewAsset(
    $id: String!
    $path: String!
    $name: String!
    $file: Upload!
  ) {
    addNewAsset(id: $id, name: $name, path: $path, file: $file)
  }
`)

export const PURGE_DELETED_PROJECT_ASSETS = gql(/* GraphQL */ `
  mutation purgeDeletedProjectAssets(
    $projectId: String!
    $groupId: String!
  ) {
    purgeDeletedProjectAssets(projectId: $projectId, groupId: $groupId)
  }
`)

export const RECOVER_DELETED_PROJECT = gql(/* GraphQL */ `
  mutation recoverDeletedProject(
    $groupId: String!
    $projectId: String!
  ) {
    recoverDeletedProject(groupId: $groupId, projectId: $projectId)
  }
`)

export const EMPTY_EXPORT_QUEUE = gql(/* GraphQL */ `
  mutation emptyExportQueue {
    emptyExportQueue
  }
`)

export const FIX_PAGES_WITH_WRONG_ID_META = gql(/* GraphQL */ `
  mutation fixPagesWithWrongIdMeta(
    $projectId: String!
    $chiliFolderName: String!
  ) {
    fixPagesWithWrongIdMeta(
      projectId: $projectId
      chiliFolderName: $chiliFolderName
    )
  }
`)

export const REMOVE_PAGES_META = gql(/* GraphQL */ `
  mutation removePagesMeta(
    $projectId: String!
    $pageIds: [String!]!
  ) {
    removePagesMeta(
      projectId: $projectId
      pageIds: $pageIds
    )
  }
`)

export const REMOVE_NON_MATCHING_PAGES_META = gql(/* GraphQL */ `
  mutation removeNonMatchingPagesMeta(
    $projectId: String!
  ) {
    removeNonMatchingPagesMeta(
      projectId: $projectId
    )
  }
`)

export const REMOVE_DUPLICATE_PAGES_META = gql(/* GraphQL */ `
  mutation removeDuplicatePagesMeta(
    $projectId: String!
  ) {
    removeDuplicatePagesMeta(
      projectId: $projectId
    )
  }
`)

export const BULK_DELETE_PROJECTS = gql(/* GraphQL */ `
  mutation bulkDeleteProjects($projectIds: [String!]!) {
    bulkDeleteProjects(projectIds: $projectIds)
  }
`)


